import React from "react";
import TopHeader from "../../Components/TopHeader";
import EmailSubscription from "../../Components/EmailSubscription";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
const Brands = () =>{

    return (
        <>
        <TopHeader/>

        <div className="featured-brands-page">
  <div className="main-container pt-0 -with-cta-banner">
    <div
      className="featured-brands-header header-fixed text-center"
      id="featuredBrandsHeader"
    >
      <div className="content">
        <h1 className="header text-capitalize">
          Our Brand Partners
        </h1>
        <p className="description mb-3">
          <span className="hurr-font-logo">
            HURR
          </span>
          toofficially powers fashion rental for over 100 of the most coveted designer and independent fashion brands. These items are marked asto
          <b>
            MANAGED
          </b>
          toon the platform.
        </p>
        to
        <Link
          className="learn-more-btn btn btn-primary -dark-red"
          to="#"
        >
          Learn More
        </Link>
        to
      </div>
    </div>
    <div className="container py-3 my-3 text-uppercase">
      <div className="col-12 item-section mx-auto">
        <div className="row">
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/acler"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1p3bbnkoceljrz43d8i00up6nl66)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAclerto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/aje"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/5jjt9j52hoee1wihdq3o755h22ed)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAjeto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/alighieri"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/3h5r2we1bsvw209czw21wyhx39bp)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAlighierito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/amanda-uprichard"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/izpg4sub8ed163n6vlh1kw10l92c)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAmanda Uprichardto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/amur"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/28fvddsvhrrqdck9eaccoo2ue3i0)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAmurto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/angelika-jozefczyk"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/c6l2x5gmh0yi9bn5jfqxj4f4r4ek)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toANGELIKA JÓZEFCZYKto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/anna-scholz"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/09oqtid6ixdyk60nh3hnlakrhs54)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toAnna Scholzto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/art-dealer"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/oqrngwo9zxzt2rfdqpsy2v5if5cw)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toArt Dealerto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/bardot"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/mpgp4wx4g5o3wja5sa9tgw3nr02b)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toBardotto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/barrus-london"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1y4opmo08g086pgtp3phmylsbha5)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toBarrus Londonto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ba-sh"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/yiycwebq08q8t22v90m4wh3syfmd)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toba&shto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/bec-bridge"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/crrrc7hpyjlk5sk5ojng8gv1dzag)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toBec & Bridgeto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/designers/boss"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/288zymypv4ys9tvkrkd9ce8hwu80)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toBossto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/bump-milk"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/z5px5bol2qaue4eex4argfbu2va0)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toBump & Milkto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/bytimo"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/w2yukcv37p0kfjndnlvfsy388lbq)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toByTiMoto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/designers/cecilie-bahnsen"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/c8626hj70r4ojdvc2gbqz6l0siju)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toCecilie Bahnsento
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/christie-nicole-bridal"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/chw9v8m5yj7n9b40o12lt5jafa79)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toChristie Nicoleto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/coperni"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/tkbqmrrjj54juwk7mgxszlt3eub4)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toCopernito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/cro-che"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/9dqivj17pfzknr6dgm08hweuvd6d)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toCro-Cheto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/designers/damson-madder"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ti4z73vl2rxbd2j8xah66np76jml)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toDamson Madderto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/de-la-vali"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ngjt5d8pcu0vt8w9e9qrmxcgsi9e)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toDe La Valito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/elliatt"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/i1tx8ieqw8owmvk2tazi2ah65spu)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toElliattto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/farai-london"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gaobmnxeefmmu00656te9pjmge9o)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toFARAI Londonto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/f-ilkk"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ofvbi7e8q3izlshjf5tskyb88v3x)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toF.ILKKto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/designers/franks-london"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/z0xjawp656wxgr9v7igwgohhc6ku)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toFRANKS Londonto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/members/freya-sim"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/l0z47no34e60046tvpites78yc6k)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toFreya Simonneto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/galvan"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/xivprp2qwsikw3x7a98fi3q2p39d)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toGalvanto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ganni"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/yc9as2ji8b9u3i10c6tbl5woldj2)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toGANNIto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ghost-london"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gh08grtbf0srfb004u0tikp3l9sg)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toGhostto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/giarite"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/f5tgnqye0qw2mokrvjcp858m36n6)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toGiaritéto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/hansen-gretel"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/093s19e5ou6uqvgjhgl4rwadkl8u)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHansen&Gretelto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/harmur"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/k3711sfdl5phz21ka03b38ppzosq)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHARMURto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/havre-studio"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/lgzy9uxz1m5ga34q3h7cycynzmr1)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHavre Studioto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/designers/hayley-menzies"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/djpd93lzgs1f7n7bh4dwoumdaqeu)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHayley Menziesto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/members/house-o"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/mnh60j19ua2t13uvrkrch4pmaa23)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHouse of Sunnyto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/members/hutch-h"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/wnovh4qc099qohgxkvayittktwyl)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toHutchto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ila"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/b9q6xgdzw1grvmstysuosoz5boxu)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toILAto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ilta"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/k58y0r5dbsmsscxhfu9dvlkdv5hd)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toILTAto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/in-the-mood-for-love"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/el5n3p64lm2wh6nnwfq41msicuqz)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toIn The Mood For Loveto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/isla-risa"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ss2a19606hnkpxld1ea66zrfkiq3)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toIsla De Garto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/jakke"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/uo120wzqemw6phezr8dgc4w9zykh)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toJakketo
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/kai-collective"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/xz6nidri55xfho0pwfkq2n4g7hy3)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toKai Collectiveto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/keepsake-the-label"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/4lttyycg2r5mk9e7bi2f1zb5im95)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toKeepsake The Labelto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/kitri"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/smk32g345hm3ctstgejodka0woez)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toKITRIto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/l-alingi"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/vcm9wnd36fttxx4covhepeivjwtd)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toL'ALINGIto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/lexi"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/jcdz39o5onnu741omwqbnymxszrd)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toLexito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/lirika-matoshi"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/oaq6t7gc0rsq8yzcuod2kf6grerp)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toLirika Matoshito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/mashu"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/vjypzslsx34l7dtbg2tl7e2p57ht)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMashuto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/mimine-ag"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gkf9yuajj8oj9uf5csmv7bapsodf)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMimine AGto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/misha"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/10qu7u7fh63b6h661po07zysphq8)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMishato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/missoma"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/x54xu8gowolq6m1phgkyuz4bht06)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMissomato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/molby-the-label"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/of8q05j5qt3x527vb8a8jti71k49)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMolby The Labelto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/mother-of-all"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/al8vmgdzlmjzf40ghg2honmaiwip)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMother Of Allto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/mulberry"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ssdc4xuqot5cckm6dzxjsu694r7z)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toMulberryto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nadine-merabi"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/goeeoh5bkhg8smc2h43re28mv7ws)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNadine Merabito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nanushka"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/qht0dhky7w0qxnlbmcmm5y3qclb0)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNanushkato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/natalie-rolt"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/nfzydx4d5w2b49qom1qm9hxhfs21)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNatalie Roltto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nensi-dojaka"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/x48tm3g1rs13e1x1biou0eevg7r9)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNensi Dojakato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nervi"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/yp1dqdbhrwvtq4mpi4vi34hpe8ae)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNervito
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/new-arrivals"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/jaf5057ahodo6tif22o06l4up2h9)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNew Arrivalsto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.ninethelabel.com/"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/rwdtd6ld5xfrs6gt4e15jsmjfcun)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNine the Labelto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nookie"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/r884gpnloktta3cyy13n6i6sipns)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNookieto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/nue-studios"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gngvdsw99vl2nn3wtz4e0dkb5j1m)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toNUÉ STUDIOto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/oceanus"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/0li501e53oh66sy7c1146eca93so)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toOceanusto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/olympia-le-tan"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/76eefg027c1wc2azom6mjvhctiq9)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toOlympia Le Tanto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/oosc"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ys6z7c3dv1i1c8u5cjcu96a0nkm2)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toOOSCto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/o-pioneers"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/hsj9f3kcx9xf11uazk61e7zyead8)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toO Pioneersto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/other-stories"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/vsomqpcudovg9wzm0g4lvz19bc4v)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  to& Other Storiesto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/overthesea"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1fgwtys6h2bl6nvfinoch8ytxq17)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toOvertheseato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/peachy-den"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/p8tle4e3d3wxhwaj2r66nv2jzt7d)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toPeachy Dento
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/pink-city-prints"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/302bg6nq9xgdr91lsnwkheziqoxr)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toPink City Printsto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/pinko"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1uu4h5v2g68a42hyn9m0pcqmxajg)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toPinkoto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/queens-of-archive"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/9p0rw8t3bnqiid29e6px7tr520m5)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toQueens of Archiveto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/racil"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1ycyo3pdrunr9j7qt7l8y8jjj8j2)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toRacilto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/rayane-bacha"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/c6vq27s58y4p1w8vbd7eu2x3bvep)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toRayane Bachato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/realisation-par"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/4dhp13cxbhd2pxvpdu6f712jdqna)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toRealisation Parto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/rezek-studio"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/v40df37ffdyv2b4tm14tpdzwy2lq)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toRezek Studioto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/ronny-kobo"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/597a3xe8rufytuiwu6et6y1j8tyy)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toRonny Koboto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/roop"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/84spimokzuj5720k0poiu5mlbv2a)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toROOPto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sabina-musayev"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gy82v7vd40atlbomitfrngj0mozc)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSabina Musayevto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sandy-liang"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/gphcmrkdmn7i6kn91vvf03s619q2)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSandy Liangto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sau-lee"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/8oriefzcxufmlz6woazahknkapsr)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSau Leeto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/saylor"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/0rgkjuz84qgk7gtkii83xcuc52m1)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSaylorto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/selkie"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/ggswpqdw5mypyg5feuws8jji4si8)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSelkieto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/seraphina"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/6ddqmyk4a1c8o0my6s8n01wmjixr)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSeraphinato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/shona-joy"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/j44altk9gco562z64uxpvkv22qnw)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toShona Joyto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sika"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/jamcguwjcmvejjmsrid48a2znvz5)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSIKAto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/silvia-astore"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/xkkbxmd1aqf9ypt1gdhmog553xj6)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSilvia Astoreto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sinead-o-dwyer"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/4qj0o63un1vz0v7ehf5szret3irx)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSINÉAD O'DWYERto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sleeper"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/4c622frr17y8kjkun9bnvgiboieh)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSleeperto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/sonya"
              >
                <div className="featured-brand-image mx-auto">
                  <div className="new-addition">
                    Just Landed
                  </div>
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/mo2evs5up15i8sxk2qt0ggvvyxtf)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSonyato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/soru-london"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/xn566cj44bnj1xyj06l3eagd1cy7)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSoru Londonto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/stand-studio"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/y0jzjq0cw3w4jw6p188aai8nwvu6)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toStand Studioto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/susamusa"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/g93yzgjcpncxjfc4s33kvd3m7cgx)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSusamusato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/susan-caplan"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/vxi1lpua0qjgs0uvb4hlkb4my23m)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toSusan Caplanto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/the-archivia"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/1zd65ai2wbutk4frlll80xpoz0qf)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toThe Archiviato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/members/the-co"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/9vo9mka3qrrbmjgz7508xjjqdstd)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toThe Coolslawto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/the-fall-bride"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/dzpnmmkmebdozt0zuy1wcdzkqn92)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toThe Fall Brideto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/the-own-studio"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/8rovk449gd1jez545l8v1cnpn7sm)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toThe Own Studioto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/the-vampire-s-wife"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/qjyxfzsq21s47p3orkg1rcpvdyfx)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toThe Vampire's Wifeto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="https://www.hurrcollective.com/members/we-are-kin-k"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/4hsq5c92djgy5dghujj3or479r17)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toWe Are Kinto
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/winona"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/v2a2sbuts45bcli5v77uuu1en1cz)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toWinonato
                </div>
              </Link>
            </div>
          </div>
          <div className="col my-3">
            <div className="text-center">
              <Link
                className="featured-brand-item text-decoration-none"
                to="/brands/wray"
              >
                <div className="featured-brand-image mx-auto">
                  <div
                    className="image"
                    style={{
                      backgroundImage: 'url(https://res.cloudinary.com/dcaptnlz3/image/upload/c_fill,f_webp,h_540,q_auto:best/xf17hjl7sssbo9yiu8t2dnhn0lkl)'
                    }}
                  />
                </div>
                <div className="designer-name mt-4 mb-2 mx-autto">
                  toWRAYto
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        <EmailSubscription/>
        <Footer/>
        </>
    )
}

export default Brands;